$('document').ready(function(){
  // menu section start here 
  $('#HeaderMenu-MenuList-2,.collectionbrandul').find('.clearfix').each((i, el) => {
    $(el).nextUntil('.clearfix').addBack().wrapAll('<li class="list-wrapper"><ul class="list-wrapper-ulblock"></ul></li>')
  });
  $('.list-wrapper-ulblock').find('.clearfixli').each((i,el) => {
    $(el).nextUntil('.clearfixli').addBack().wrapAll('<li class="list-wrapper-innerblock"><ul class="list-wrapper-ulinnerblock"></ul></li>')
  });
  $('#ola_orderLookUp_formWrapper').append('<p class="contactus-link center">Need help? <a href="https://www.hydrafil.com/pages/contact-us">Contat Us</a></p>');
  $('.cart__body-wrapper,.cart__footer-wrapper').wrapAll('<div class="customcartbody"><div class="page-width"></div></div>')
  // collection section start here 
  $("body").click(function(){
    $('.collectionbranddropdown').slideUp();
    $('.collectionbradsectionblock').removeClass('openbrandblock');
  });
  $('#branddorpdownbutton').click(function(e){
    e.stopPropagation();
    $('.collectionbranddropdown').slideDown();
    if($('.collectionbranddropdown').css('display','block')){
      $('.collectionbradsectionblock').addClass('openbrandblock');
    }
    else{
      $('.collectionbradsectionblock').removeClass('openbrandblock');
    }
  });
  var buttonhtml = $('.wpd_half.Second .action_bottom').html();
  $('.wpd_half.First').append('<div class="action_bottom">' + buttonhtml + '</div>' );
  $('.wpd_half.Second .action_bottom').remove();
  $('.wpd_half.Second').before().append('<button class="primary-button button" type="button" id="continueBusiness">Continue</button>');  
  $('#wpd-create-customer #create_customer').before().append('<div class="tabinblock-section"><a id="personaldata" data-tab="1" class="tab active" href="javascript:;"><span>1</span>Personal data</a><span class="line"></span><a id="businessdetails" data-tab="2" class="tab" href="javascript:;"><span>2</span>Business Details</a></div>');
  $('.wpd_half.First').append().attr({'data-tab': "2",id: "Tcontent2"}).css('display','none');
  $('.wpd_half.Second').append().attr({'data-tab': "1",id: "Tcontent1"}).addClass('active');
  $('.tabinblock-section a').on('click', function(){
      var target = $(this).attr('data-tab');
      $('.tabinblock-section a').removeClass('active');
      $(this).addClass('active');
      $("#Tcontent"+target).fadeIn('slow').siblings(".wpd_half").hide();
      return false;
  });
  $('#continueBusiness').click(function(ev){
    $('.wpd_half.Second').removeClass('active');
    $('.wpd_half.First').addClass('active');
    $('.tab[data-tab="1"]').removeClass('active');
    $('.tab[data-tab="2"]').addClass('active');
    $("#Tcontent"+2).fadeIn('slow').siblings(".wpd_half").hide();
  });
  
   $('.action_bottom .wpd_submit').click(function(ev) {
    var $this = this;
    ev.preventDefault();
    var CustomerObj = {};
    CustomerObj['address1'] = $('#wpd_comp_address').val();
    CustomerObj['address2'] = $('#wpd_comp_address_2').val();
    CustomerObj['city'] = $('#wpd_city').val();
    CustomerObj['zip'] = $('#wpd_postal_code').val();
    CustomerObj['country'] = $('#wpd_country').val();
    CustomerObj['province'] = $('#wpd_AddressProvince').val();
    CustomerObj['first_name'] = $('#wpd_first_name').val();
    CustomerObj['last_name'] = $('#wpd_last_name').val();
    CustomerObj['phone'] = $('#wpd_phone_number').val();
    CustomerObj['email'] = $('#wpd_email').val();
    CustomerObj['shop'] = 'hydrafil-store.myshopify.com';
    CustomerObj['company'] = $('#wdp_company').val();
    var mailformat = /^\w+[^@]+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
    var note = '';
    var extradata = '';
    if ($('#wpd_title').val() != '') {
      note = note + '\\r\\n\\r\\n Title: ' + $('#wpd_title').val();
    }
    if ($('#wpd_website').val() != '') {
      note = note + '\\r\\n\\r\\n Website: ' + $('#wpd_website').val();
    }
    if ($('#wdp_company').val() != '') {
      note = note + '\\r\\n\\r\\n Company: ' + $('#wdp_company').val();
    }
    if ($('#wpd_tax_id').val() != '') {
      note = note + '\\r\\n\\r\\n Tax ID: ' + $('#wpd_tax_id').val();
    }
    if (window.FieldValidation() == false) {
      return false;
    }
    if (!CustomerObj['email'].match(mailformat)) {
      $('#wpd_email').focus().addClass('RequiredFields');
      $('.errormsg').html('You have entered an invalid email address!');
      setTimeout(function() {
        $('.errormsg').html('')
      }, 1500);
      return false;
    }
    $('.wpd_loader').show();
    $($this).prop("disabled", true);
    setTimeout(() => {
      if ($('#ExtraFields').val() != '') {
        extradata = $('#ExtraFields').val();
        note = note + extradata;
      }
      CustomerObj['note'] = note;
      var wpdsend = JSON.stringify(CustomerObj);
      var route = "https://wpd.wholesalehelper.io/api/storefront/create-customer";
      fetch(route, {
        method: 'POST',
        body: wpdsend,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
      }).then(response => {
        $('.wpd_loader').hide();
        $($this).prop("disabled", false);
        if (response.ok) {
          response.json().then(function(data) {
            if (data.response.customer.hasOwnProperty('id')) {
              var msg = "Your account has been created successfully.";
              if (data.Successmsg) {
                msg = data.Successmsg;
              }
              $('.successmsgheader').html(msg);
              $('#wpd-create-customer').html('');
              $('#wpd_reload').show();
            } else {
              var msg = "Email or phone number already exists. Please sign up with a different email or phone number.";
  
              if (data.hasOwnProperty('Error') && data.Error.indexOf('has already been taken') != -1) {
                if (window.wpd_signup_error_message == undefined) {
                  msg = 'The email has already been taken';
                } else {
                  msg = window.wpd_signup_error_message;
                }
  
              }
              $('.errormsgheader').html(msg);
              $($this).prop("disabled", false);
            }
          });
        } else {
          $('#wpd-create-customer').html('');
          $('#wpd_reload').show();
  
          var msg = 'something went wrong! Please try again';
          $('.errormsg').html(msg);
        }
  
      });
  
    }, 3000);
  });
  });
  // collection section load more button start here 
  $(document).on('click','.js-load-more', function(){
    console.log('hello');
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    var currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    console.log(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('#product-grid').append($(responseHTML).find('#product-grid').html());
      },
      complete: function() {
        console.log(currentPage,totalPages,currentPage <= totalPages)
        if(currentPage <= totalPages) {
           $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        }
        if(currentPage == totalPages){
          $this.addClass('hide');
        }
      }
    })
  });
  // $(window).on("load", function() {
  //   const addPageLink = setInterval(function(){    
  //   $('.shopify-payment-button__more-options').text('Buy Now');
  //     $(document).on('click','.shopify-payment-button__more-options',function() {
  //       console.log($('this').text());
  //       $('this').text('Buy Now');
  //     });
  //     clearInterval(addPageLink); 
  //   },1000);
  // });
  $('document').ready(function(){
    const addPageLink = setInterval(function(){    
    $('.shopify-payment-button__more-options').text('Buy Now');
      $(document).on('click','.shopify-payment-button__more-options',function() {
        console.log($('this').text());
        $('this').text('Buy Now');
      });
      clearInterval(addPageLink); 
    },3000);
    // setTimeout(function() {
    //   $('.shopify-payment-button__more-options').text('Buy Now');
    // }, 3000); 
  })
  $('.shopify-payment-button__more-options').click(function() {
    setTimeout(function() {
      $(this).text('Buy Now'); 
    }, 1000); 
  });
  $('form[data-type="add-to-cart-form"]').submit(function() {
    setTimeout(function() {
      $('.shopify-payment-button__more-options').text('Buy Now');
      
    }, 1000); 
    console.log($('.shopify-payment-button__more-options').text('Buy Now'))
  });
  $('form[data-type="add-to-cart-form"]').click(function() {
    setTimeout(function() {
      $('.shopify-payment-button__more-options').text('Buy Now');
    }, 1000); 
    console.log($('.shopify-payment-button__more-options').text('Buy Now'))
  });
  
  